import Toggle from 'components/Toggle/TogglePresentation'

export default Toggle
